import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=7b196287&scoped=true&"
import script from "./blank.vue?vue&type=script&lang=ts&"
export * from "./blank.vue?vue&type=script&lang=ts&"
import style0 from "./blank.vue?vue&type=style&index=0&id=7b196287&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b196287",
  null
  
)

export default component.exports